import KunLoading82 from './src/index'

KunLoading82.install = function (Vue) {
	Vue.component(KunLoading82.name, KunLoading82);
}

export default KunLoading82;
